import { Component, Inject, ViewChild, ElementRef, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, NgModel } from '@angular/forms';
import { DialogBase, T4Image, ImageType, User, ComponentBase, PageBase } from 't4core';
import { Router } from '@angular/router';
import { FindUserDialog } from '../../dialogs/FindUserDialog/FindUserDialog';
import { ChangePasswordDialog } from '../../../../turbo/dialogs/changePassword/changePassword';
import { MatDialog } from '@angular/material/dialog';
import { ServiceGuyInfo } from '../../../../../projects/t4core/src/public-api';
import { map, startWith } from 'rxjs/operators';
//import { FindUserDialog } from '../../dialogs/FindUserDialog/FindUserDialog';

@Component({
    selector: 'EditUserComponent',
    templateUrl: 'EditUserComponent.html',
    styleUrls: ['./EditUserComponent.css']
})
export class EditUserComponent extends ComponentBase {

    @ViewChild("txtUsername", { static: false }) public txtUsername: NgModel;
    @ViewChild("txtEmail", { static: false }) public txtEmail: NgModel;
    @ViewChild("txtPassword", { static: false }) public txtPassword: NgModel;
    @ViewChild("txtMobilePhone", { static: false }) public txtMobilePhone: NgModel;
    @ViewChild("txtcontactPhone", { static: false }) public txtcontactPhone: NgModel;
    @ViewChild("txtApi", { static: false }) public txtApi: NgModel;
    @ViewChild("txtContextId", { static: false }) public txtContextId: NgModel;

    @Input() public _user: User;
    @Input() public newUser: boolean = false;
    @Output() newUserCreated = new EventEmitter<User>();
    @Input() public editable: boolean = true;
    public password: string = "";
    public isApi: boolean = false;
    public roles: any[];
    public userRoles: any[];
    public manager: string;
    public serviceGuys: ServiceGuyInfo[] = [];
    public serviceGuy: ServiceGuyInfo;
    public formattedServiceGuy: string;
    public txtServiceGuy = new FormControl("");

    @Input() set user(value: User) {
        this._user = value;
      if (value) {
        this.loadEverything();
      }
    }

  constructor(el: ElementRef, private router: Router, private dialog: MatDialog) {
    super();
    }

  public async ngOnInit() {
    console.log(  this.newUser);
      if (this.newUser) {
        this._user = new User();
        this._user.Username = "";
        this._user.Email = "";
        this._user.Phone = "";
        this._user.IsApi = false;

        this.getRoles();
      }
    }

    public async loadEverything() {
        await this.getUserInfo();
        await this.getRoles();
        await this.getServiceGuys();
    }

  public async getUserInfo() {
    if (this._user) {
      if (this.Settings.isInAny(['Admin', 'BackOffice'], true)) {
        this._user = await this.Api.get("Account/GetInfoForOtherUser", { userName: this._user.Username });
      }
      else {
        this._user = this.Settings.getUser();
      }
      var token = this.UI.beginLoading("T4.Settings.EditUser.msgLoading", "Loading user", null);
      this.UI.loaderCompleted(token);
    }

    if (!this._user) {
      alert('No user was found!');
    }
    else {
      if (this._user.Hierarchy) {
        var m = this._user.Hierarchy.split(" ->");
        for (let i = 0; i < m.length; i++) {
          if (m[i] == this._user.Username && i > 0) {
            this.manager = m[i - 1];
            break;
          }
        }
      }
    }
  }

    public async save() {
        var token = this.UI.beginLoading("T4.Settings.EditUser.msgSaving", "Saving user", null);
        this.loading = true;
      var success = false;
      var errorDescription = "";
      if (this.newUser) {
          var identityResult = await this.Api.post<any>("Account/CreateUser", null, { username: this._user.Username, password: this.password, isApi: this._user.IsApi, ContextId: this._user.ContextId, email: this._user.Email, phone: this._user.Phone });
          if (identityResult.Succeeded) success = true;
          else {
            success = false;
            errorDescription = identityResult.Errors.map(e => e.Description).join("; ");
          }
        }
        else {
          if (this.Settings.isInAny(['Admin', 'BackOffice'], true)) {
            success = await this.Api.post("Account/EditOtherUserInfo", null, { userName: this._user.Username, isApi: this._user.IsApi, ContextId: this._user.ContextId, email: this._user.Email, phone: this._user.Phone, serviceguyId: this.serviceGuy?.Id });
          }
          else {
            await this.Api.post("Account/EditUserInfo", null, { username: this._user.Username, email: this._user.Email, language: null, phone: this._user.Phone });
            success = true;
          }
        }
        this.UI.loaderCompleted(token);

      if (!success) {
        this.UI.alert("Turbo.Settings.EditUserComponent.Save.titleFailed", "Failed!", "Turbo.Settings.EditUserComponent.Save.msgFailedErrorDesc", "The settings could not be saved. {0}", null, [errorDescription]);
        }
        else {
            if (this.newUser) {
                this.newUser = false;
                this.newUserCreated.emit(this._user);
            }
            var token = this.UI.beginLoading("T4.Settings.EditUser.msgSavingRoles", "Saving roles for user. Please wait a moment...", null);
            var addRoles = await this.Api.post<any[]>("Settings/SetRolesForUser", this.userRoles, { userName: this._user.Username });
            this.UI.loaderCompleted(token);
            if (!addRoles) {
                this.UI.alert("Turbo.Settings.EditUserComponent.Save.titleFailed", "Failed!", "Turbo.Settings.EditUserComponent.Save.msgFailedRoles", "The settings regarding roles could not be saved.");
            }
            else {
                this.UI.alert("Turbo.Settings.EditUserComponent.Save.titleSuccess", "Settings saved!", "Turbo.Settings.EditUserComponent.Save.msgSuccess", "The settings have been saved.");
            }
        }
        this.loading = false;
    }

    public async changePassword() {
      let dialogRef = this.dialog.open(ChangePasswordDialog, {
        data: {}
      });

      dialogRef.afterClosed().subscribe(result => { });
    }

    public async resetPassword() {
        if (!this._user.Email || this._user.Email.length == 0) {
            this.UI.alert("Turbo.Settings.EditUserComponent.Save.titleFailed", "Failed!", "Turbo.Settings.EditUserComponent.ResetPassword.EmailMissingMsg", "Please enter a valid email.");
            return;
        }
        var x = await this.UI.confirm("Turbo.Settings.EditUserComponent.ResetPasswordConfirmation.RemoveUserConfirmationTtl", "Are you sure?", "Turbo.Settings.EditUserComponent.ResetPasswordConfirmation.ResetPasswordConfirmationMsg", "Do you want to reset the password for this user? The new password will be sent to {0}.", null, [this._user.Email]);
        if (x) {
           var token = this.UI.beginLoading("T4.Settings.ResetPassword.msgSendingEmail", "Sending an email. Please wait a moment...", null);
          var content: any = await this.Api.post("Account/ResetPassword", null, { username: this._user.Username });
          this.UI.loaderCompleted(token);

          //If there is no content, no result or  if the result isn't Ok (0)
          if (!content) {
              await this.UI.alert("Turbo.General.FailedEmailSending", "Failed!", "Turbo.General.FailedEmailSendingMsg And Reset", "Failed to send an email and reset password!");
          }
          //If we have content, but we cant send the email for some reason.
          else if (content && content.EmailStatus != 0) {
            await this.UI.alertBox({
              headline: "Turbo.App.headResetPasswordSuccessNoEmail",
              headlineDefault: "Email Failed to send, Password reseted",
              message:
               `Email: ${content.Email} <br>
                Username: ${content.User.Username} <br> 
                Password: ${content.User.Password} <br>`
            });
          }
            else {
              await this.UI.alertBox({
                headline: "Turbo.App.headResetPasswordSuccess2",
                headlineDefault: "Passwords have been reset!",
                message:
               `Email: ${content.Email} <br>
                Username: ${content.User.Username} <br> 
                Password: ${content.User.Password} <br>`
              });
            }
      }
    }

    public async removeUser() {
        var x = await this.UI.confirm("Turbo.Settings.EditUserComponent.RemoveUserConfirmationTtl", "Are you sure?", "Turbo.Settings.EditUserComponent.RemoveUserConfirmation.RemoveUserConfirmationMsg", "Do you want to remove this user?");

        if (x) {
            var token = this.UI.beginLoading("T4.Settings.EditUser.msgRemoving", "Removing user", null);
            var success = await this.Api.post("Account/RemoveUser", null, { username: this._user.Username });
            this.UI.loaderCompleted(token);

            if (!success) {
                await this.UI.alert("Turbo.General.FailedTtl", "Failed!", "Turbo.General.FailedMsg", "The action failed!");
            }
            else {
                await this.UI.alert("Turbo.General.SuccessTtl", "Success!", "Turbo.General.SuccessMsg", "The action has been performed succesfully!");
            }
        }
    }

    public async changeManager() {
      //Not finished yet

      var title = await this.translate('T4.Settings.EditUser.SetManager', 'Set manager');
      var save = await this.translate('Turbo.OneWayAdmin.UserManagement.Actions.cmdSave', 'Save');
      var user = await this.Dialog.open(FindUserDialog, { width: '500px', data: { title: title, saveButtonText: save } }).afterClosed().toPromise();
      if (user) {}
      else { }
    }

    public async setApi(isApi: any) {
      this._user.IsApi = isApi;
    }

  public async getRoles() {
    var token = this.UI.beginLoading("T4.Settings.EditUser.msgLoadingRoles", "Loading roles", null);
    this.roles = await this.Api.get<any[]>("Settings/GetRoles");
    if (!this.newUser) { 
      var userRoles = await this.Api.get<any[]>("Settings/GetRolesForUser", { userName: this._user.Username });

      this.userRoles = [];
      for (let role of userRoles) {
        this.userRoles.push(role.Id);
      }
    }
      this.UI.loaderCompleted(token);
  }


  public async getServiceGuys() {
    this.serviceGuys = await this.Api.get<ServiceGuyInfo[]>("Service/GetServiceGuys");

    this.serviceGuy = await this.serviceGuys.find(x => x.Id == this._user.ServiceGuyId)

    if (this.serviceGuys != null)
      this.formattedServiceGuy = this.formatServiceGuy(this.serviceGuy);
    else this.formattedServiceGuy = "";
    
  }


  public selectedServiceGuy(sg: ServiceGuyInfo) {
    if(sg != null)
    this.serviceGuy = sg;
  }

  public formatServiceGuy(sg: ServiceGuyInfo) {
    if(sg != null)
      return `${sg.Companyname ? sg.Companyname + ' - ' : ''}${sg.Firstname ? sg.Firstname + ' ' : ''}${sg.Lastname ? sg.Lastname + ' - ' : ''}${sg.Email ? sg.Email + ' - ' : ''}${sg.Phone ? sg.Phone : ''}`;

    return "";
  }

  filteredServiceGuys = this.txtServiceGuy.valueChanges.pipe(
    map(value => this._filterServiceGuys(value))
  );

  private _filterServiceGuys(value: string): ServiceGuyInfo[] {
    const filterValue = value.toLowerCase();
    return this.serviceGuys.filter(guy =>
      guy.Firstname.toLowerCase().includes(filterValue) ||
      guy.Lastname.toLowerCase().includes(filterValue) ||
      guy.Companyname.toLowerCase().includes(filterValue) ||
      guy.Phone.toLowerCase().includes(filterValue) ||
      guy.Email.toLowerCase().includes(filterValue));
  }


}
